module.exports = __webpack_public_path__ + "media/country_flags/za-b19b2700.png";